import React, { useState } from 'react'
import { Search, Remove } from '../../atoms/NewIcons'

const SearchField = ({ size, disabled, placeholder, handleSearch }) => {
  const [status, setStatus] = useState('')
  const [currentValue, setCurrentValue] = useState('')

  function handleValueChange(event) {
    setStatus(event.target.value ? 'filled' : '')
    setCurrentValue(event.target.value)
    handleSearch(event.target.value)
  }

  const annullaRicerca = () => {
    if (status == 'filled') {
      setCurrentValue('')
      setStatus('')
      handleSearch('')
    }
  }

  return (
    <div className={'search-field search-field--' + (size ? size : 'lg')}>
      <input
        className="search-field__input"
        value={currentValue}
        placeholder={placeholder}
        aria-label={placeholder}
        onChange={handleValueChange}
        disabled={disabled}
      />
      <a className="search-field__icon" onClick={annullaRicerca}>
        {status == 'filled' ? <Remove /> : <Search />}
      </a>
    </div>
  )
}

export default SearchField
